import { Injectable } from '@angular/core';
import {
  isReviewApplicationsDetailRoute,
  isReviewApplicationsListRoute,
} from '../utils/sidebar-nav.util';

/**
 * Collapses the main nav when opening an application detail/review workspace,
 * and restores the list-page collapsed state when navigating back (e.g. breadcrumb).
 */
@Injectable({ providedIn: 'root' })
export class SidebarNavService {
  /** Sidebar collapsed state on the list page before entering a detail route. */
  private listCollapsedBeforeDetail = false;

  /**
   * @returns Next sidebar collapsed state, or `undefined` when navigation should not change it.
   */
  resolveSidebarForNavigation(
    previousUrl: string,
    nextUrl: string,
    currentCollapsed: boolean
  ): boolean | undefined {
    if (isReviewApplicationsDetailRoute(nextUrl)) {
      if (isReviewApplicationsListRoute(previousUrl)) {
        this.listCollapsedBeforeDetail = currentCollapsed;
      }
      return true;
    }

    if (
      isReviewApplicationsDetailRoute(previousUrl) &&
      isReviewApplicationsListRoute(nextUrl)
    ) {
      return this.listCollapsedBeforeDetail;
    }

    return undefined;
  }
}
